import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarrinhoComponent } from './carrinho.component';
import { CarrinhoRoutingModule } from './carrinho.routes';
import { CarrinhoService } from './carrinho.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { AuthModule } from '@app/auth/auth.module';
import { MatIconModule } from '@angular/material/icon';
import { ItemComponent } from './item/item.component';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [CarrinhoComponent, ItemComponent],
  imports: [
    AuthModule,
    CarrinhoRoutingModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatTabsModule,
    NgxMaskModule.forRoot(),
    ReactiveFormsModule,
  ],
  exports: [],
  providers: [CarrinhoService],
})
export class CarrinhoModule {}
